import { useState } from 'react';
import apiClient from '../../../Services/ApiClient';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';

export default function usePatientAddressContainer() {
	const [isLoading, setIsLoading] = useState(false);
	const addAddressContainerToScheme = async (formScheme: ItemScheme[]) => {
		setIsLoading(true);
		const address = await apiClient.get('/wizard/addressContainer/tree', {});
		if (address?.data) {
			const addressFields: ItemScheme[] = [];
			address.data.forEach((item: any) => {
				addressFields.push(item);
			});

			formScheme.push({
				type: MagicField.CONTAINER,
				key: 'address',
				children: addressFields,
			});
		}
		setIsLoading(false);
		return formScheme;
	};

	return { addAddressContainerToScheme, isLoading };
}
